// Generated by Melange

import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__LoadingSpinner from "../../../atoms/LoadingSpinner.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__Bytes from "melange/bytes.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import CloseSvg from "static/icons/close.svg";

function make(name) {
  return function (value) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("label", {
                        children: name,
                        className: "block text-sm leading-5 text-gray-500"
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("p", {
                              children: value,
                              className: "text-base leading-5"
                            }),
                        className: "mt-1 sm:mt-0 sm:col-span-2"
                      })
                ],
                className: "sm:grid sm:grid-cols-5 sm:gap-4 items-center md:grid-cols-8 lg:grid-cols-10"
              });
  };
}

function KeyItem$InfoSectionItem(Props) {
  return make(Props.name)(Props.value);
}

const InfoSectionItem = {
  make: KeyItem$InfoSectionItem
};

function KeyItem(Props) {
  let id = Props.id;
  const func = Buhta_cabinet__Keychain.KeyService.view;
  const match = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func, param, {
                      hd: "content",
                      tl: /* [] */0
                    }, id);
        }), undefined);
  const dispatch = match[1];
  const model = match[0];
  React.useEffect((function () {
          Curry._2(dispatch, undefined, undefined);
        }), [id]);
  if (typeof model === "string") {
    return JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
                className: "animate-fadeIn"
              });
  }
  if (model.NAME === "Data") {
    const item = model.VAL;
    const org = item.org;
    const content = item.content;
    const content$1 = item.content;
    let tmp;
    if (content$1 !== undefined) {
      const keyUsage = item.key_usage;
      const keySerialNo = item.key_serial_no;
      const p12 = Stdlib__Bytes.to_string(content$1.p12);
      tmp = JsxRuntime.jsx("a", {
            children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                  size: "s",
                  kind: "default",
                  onClick: (function (param) {
                      
                    }),
                  children: "Скачать .p12"
                }),
            download: "" + keyUsage + "-" + keySerialNo + ".p12",
            href: "data:application/x-pkcs12;base64," + p12
          });
    } else {
      tmp = "\xe2\x80\x94";
    }
    return JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                title: "",
                leftActions: {
                  hd: JsxRuntime.jsx("button", {
                        children: JsxRuntime.jsx(CloseSvg, {}),
                        onClick: (function (param) {
                            Buhta_cabinet__Route.navigateTo({
                                  TAG: /* Admin */7,
                                  _0: {
                                    TAG: /* Keychain */0,
                                    _0: {
                                      TAG: /* Keys */0,
                                      _0: /* List */0
                                    }
                                  }
                                });
                          })
                      }),
                  tl: /* [] */0
                },
                rightActions: {
                  hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                        size: "s",
                        kind: "default",
                        onClick: (function (param) {
                            Buhta_cabinet__Route.navigateTo({
                                  TAG: /* Admin */7,
                                  _0: {
                                    TAG: /* Keychain */0,
                                    _0: {
                                      TAG: /* Keys */0,
                                      _0: {
                                        TAG: /* Edit */1,
                                        _0: id
                                      }
                                    }
                                  }
                                });
                          }),
                        children: "Редактировать"
                      }),
                  tl: /* [] */0
                },
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                              className: "mb-6 text-default-gray",
                              children: "Учетные данные"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(KeyItem$InfoSectionItem, {
                                      name: "Предприятие",
                                      value: org !== undefined ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                              route: {
                                                TAG: /* Admin */7,
                                                _0: {
                                                  TAG: /* Orgs */1,
                                                  _0: /* Org */{
                                                    _0: org.id,
                                                    _1: /* Dashboard */0
                                                  }
                                                }
                                              },
                                              className: "mt-0",
                                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    className: "hover:text-primary-lite text-links",
                                                    children: org.name
                                                  })
                                            }) : null
                                    }),
                                JsxRuntime.jsx(KeyItem$InfoSectionItem, {
                                      name: "Название",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: item.name
                                          })
                                    }),
                                JsxRuntime.jsx(KeyItem$InfoSectionItem, {
                                      name: "Пароль",
                                      value: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: content !== undefined ? content.password : "\xe2\x80\x94"
                                          })
                                    }),
                                JsxRuntime.jsx(KeyItem$InfoSectionItem, {
                                      name: "Сайт",
                                      value: tmp
                                    })
                              ],
                              className: "flex flex-col space-y-2"
                            })
                      ],
                      className: "p-6"
                    })
              });
  }
  console.log("grpc error", model.VAL);
  return "Ошибка: " + "TODO: Unwrap grpc error";
}

const make$1 = KeyItem;

export {
  InfoSectionItem ,
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
